import { CloseOutlined, SaveOutlined } from '@ant-design/icons';
import { Button, Layout } from 'antd';
import useTranslation from 'next-translate/useTranslation';
import React from 'react';

export interface OnboardingHeaderProps {
  title: React.ReactNode;
  isSiderHidden: boolean;
  showMobileMenu: (value: boolean) => void;
  onSaveAndExit?: () => void;
  handleExitClick: () => void;
  portalNode?: React.ReactNode;
}

export function OnboardingHeader({
  title,
  isSiderHidden,
  showMobileMenu,
  onSaveAndExit = undefined,
  handleExitClick,
  portalNode,
}: OnboardingHeaderProps) {
  const { t } = useTranslation('common');

  return (
    <Layout.Header className="flex items-center justify-between !leading-normal">
      <div>
        {isSiderHidden && (
          <Button
            className="mr-2"
            type="text"
            size="small"
            onClick={() => showMobileMenu(isSiderHidden)}
          >
            {t('menu')}
          </Button>
        )}
        {!isSiderHidden && <div className="text-gray-700">{title}</div>}
      </div>
      <div className="flex items-center space-x-2">
        {portalNode && portalNode}
        {onSaveAndExit !== undefined && (
          <Button
            type="link"
            size="large"
            icon={<SaveOutlined className="text-sm" />}
            onClick={onSaveAndExit}
            data-test="onboarding-header-update-btn"
          >
            {t('update')}
          </Button>
        )}
        <Button
          shape="circle"
          icon={<CloseOutlined />}
          onClick={handleExitClick}
          data-test="onboarding-header-close-btn"
        />
      </div>
    </Layout.Header>
  );
}

export default OnboardingHeader;
